export const namespaceInitialState = {
    namespaceList: []
}